import { SharedViewActionType } from '../../enums/view-enums';

export class ActionViewModel {

    ActionTitle: string;
    ActionURL: string;
    ActionType: SharedViewActionType | null;

    constructor(actionTitle: string | '', actionURL: string | '', actionType: SharedViewActionType | null) {
        this.ActionTitle = actionTitle;
        this.ActionURL = actionURL;
        this.ActionType = actionType;
    }

}
